module.exports = __webpack_public_path__ + "static/img/call.0fb7f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/call.png
// module id = 475
// module chunks = 0 1 2 3 4 5 6 7 8